export default "__VITE_ASSET__DV6pRSC2__"